/**
 * Mandat
 */
export interface MandateDto {
    //Id du mandat
    id: string;
    //id de l'utilisateur enregistré chez SDDEA
    userExtId: string;
    // niveau d'accès sur ce mandat précis
    accessRole?: string;
}

/**
 * Type de mandats
 */
export enum MandateType {
    AG = 'AG',
    BSCA = 'BSCA',
    EAU = 'EAU',
    ASSAINISSEMENT = 'ASSAINISSEMENT',
    BASSIN = 'BASSIN',
    TERRITOIRE = 'TERRITOIRE',
    COMMISSIONS = 'COMMISSIONS',
}

/**
 * Type des onglets
 */
export enum TabType {
    MEETING,
    MEETINGFILE,
    MAP,
    COMPOSITION,
    HOLDINGS,
    DECISIONDELIBERATION,
    INDICATOR,
    FINANCES,
    RELATION,
    DOCUMENTS,
    ASSIGNMENTS,
    COMMISSIONS,
}
